const translations = {
  jp: {
    nav: {
      about: "会社概要",
      services: "事業内容",
      vision: "ビジョン",
      contact: "お問い合わせ",
      cta: "ご相談",
    },
    hero: {
      eyebrow: "MEIKI REAL ESTATE SERVICES",
      titleLines: ["Step into a world of", "new possibilities", "in Japan."],
      subtitle: "鳴奇株式会社",
      description:
        "単なるサービスではなく、日本という地で「住まう・育つ・繋がる」体験への架け橋を提供します。",
      primary: "事業内容を見る",
      secondary: "お問い合わせ",
    },
    marquee: [
      "TOKYO",
      "REAL ESTATE",
      "EDUCATION",
      "CROSS-BORDER",
      "TRUST",
      "SINCE",
    ],
    about: {
      eyebrow: "01 — ABOUT",
      title: "日本と世界をつなぐ、信頼の架け橋。",
      paragraphs: [
        "東京は日本の中心都市として、常に注目を集める不動産市場の一つです。充実した都市インフラ、安定した市場環境、そして継続的な発展の可能性により、多くのお客様にとって居住用・投資用の不動産購入の重要な選択肢となっています。",
        "鳴奇株式会社は、世界中の顧客に向けて、専門的で効率的かつ信頼できるクロスボーダーサービスプラットフォームを提供することを目指しています。日本を拠点とし、中国および国際市場とをつなぎ、不動産・留学・カスタマイズ型コンサルティングをワンストップでご提供します。",
      ],
      stats: [
        { value: "東京", label: "本社所在地" },
        { value: "Multi", label: "多言語対応" },
        { value: "1:1", label: "オーダーメイド" },
      ],
    },
    services: {
      eyebrow: "02 — SERVICES",
      title: "二つの専門領域で、確かな価値を。",
      items: [
        {
          number: "I",
          tag: "REAL ESTATE",
          title: "不動産事業",
          description:
            "東京エリアの市場状況や発展動向を深く理解し、お客様一人ひとりのニーズに応じて、物件のご紹介、投資分析、取引手続きのサポートまで、一連のサービスを提供します。",
          highlights: [
            "東京エリアに精通した市場分析",
            "居住用・投資用物件のご提案",
            "多言語対応による安心のサポート",
            "取引手続きの一貫した代行",
          ],
        },
        {
          number: "II",
          tag: "EDUCATION",
          title: "日本語学校への留学生紹介事業",
          description:
            "東京エリアの複数の日本語学校と提携し、学生の学習計画や個々の状況に応じて適切な学校を提案。出願申請からビザ取得まで一貫してサポートします。",
          highlights: [
            "提携校が豊富で選択肢が広い",
            "出願書類の作成サポート",
            "ビザ申請までの一貫支援",
            "渡日後の生活サポートにも配慮",
          ],
        },
      ],
    },
    vision: {
      eyebrow: "03 — VISION",
      title: "専門性・誠実さ・革新。",
      body:
        "鳴奇株式会社は、これからも専門性・誠実さ・革新の理念を大切にし、日本と世界をつなぐ重要な架け橋となることを目指してまいります。お客様に長期的な価値とさらなる可能性を創出していくことを使命としています。",
      pillars: [
        { title: "Expertise", desc: "豊富な業界経験と専門知識" },
        { title: "Integrity", desc: "誠実さに根ざした長期的信頼" },
        { title: "Innovation", desc: "時代に応える革新的な発想" },
      ],
    },
    contact: {
      eyebrow: "04 — CONTACT",
      title: "ご興味がありましたら、お気軽に。",
      description:
        "ご質問・ご相談・物件のお問い合わせなど、お気軽にご連絡ください。専任スタッフが多言語で対応いたします。",
      address: "〒134-0088 東京都江戸川区西葛西5-10-13 栄華ビル4F",
      tel: "03-6808-8841",
      fax: "03-6808-8845",
      license: "東京都知事(1)112938号",
      lineCta: "LINEでお問い合わせ",
      emailCta: "メールでお問い合わせ",
    },
    footer: {
      tagline: "Bridge between Japan and the world.",
      copyright: "© 2026 鳴奇株式会社 MEIKI Co., Ltd. All rights reserved.",
    },
  },

  zh: {
    nav: {
      about: "公司简介",
      services: "业务领域",
      vision: "企业愿景",
      contact: "联系我们",
      cta: "咨询",
    },
    hero: {
      eyebrow: "MEIKI REAL ESTATE SERVICES",
      titleLines: ["在日本，", "发现新的", "可能性。"],
      subtitle: "鸣奇株式会社",
      description:
        "我们提供的不仅是服务，更是一座桥梁——让您在日本不只是抵达，而是真正生活、成长、归属。",
      primary: "查看业务",
      secondary: "联系我们",
    },
    marquee: [
      "东京",
      "不动产",
      "留学",
      "跨境服务",
      "值得信赖",
      "专注",
    ],
    about: {
      eyebrow: "01 — 关于我们",
      title: "连接日本与世界的桥梁。",
      paragraphs: [
        "东京作为日本的核心城市，是全球瞩目的不动产市场之一。完善的城市基础设施、稳定的市场环境与持续的成长潜力，使其成为众多客户在自住与投资之间的重要选择。",
        "鸣奇株式会社致力于为全球客户搭建专业、高效、值得信赖的跨境服务平台。立足日本，连接中国与国际市场，为客户提供日本不动产、留学服务与定制化咨询的一站式解决方案。",
      ],
      stats: [
        { value: "东京", label: "总部所在地" },
        { value: "语言", label: "全程支持" },
        { value: "1:1", label: "定制化方案" },
      ],
    },
    services: {
      eyebrow: "02 — 业务领域",
      title: "两大专业版块，传递确定的价值。",
      items: [
        {
          number: "I",
          tag: "REAL ESTATE",
          title: "不动产事业",
          description:
            "深耕东京区域市场，深入理解各区域行情与发展趋势。从物件介绍、投资分析到交易手续，提供完整的全流程服务，让您的日本不动产交易更顺畅。",
          highlights: [
            "深入了解东京各区行情",
            "自住与投资物件全面覆盖",
            "多语种对接，沟通无障碍",
            "全流程交易手续代办",
          ],
        },
        {
          number: "II",
          tag: "EDUCATION",
          title: "日本语学校留学申请",
          description:
            "与东京多所日本语学校建立合作关系，依据学生的学习规划与个人情况推荐合适学校，并提供从材料准备到签证办理的一站式支持。",
          highlights: [
            "合作学校众多，选择面广",
            "申请材料专业指导",
            "签证申请全程跟进",
            "落地后生活贴心关怀",
          ],
        },
      ],
    },
    vision: {
      eyebrow: "03 — 企业愿景",
      title: "专业 · 诚信 · 革新。",
      body:
        "鸣奇株式会社将继续秉持专业、诚信、革新的理念，致力于成为连接日本与世界的重要桥梁，为客户创造长期价值与更多可能。",
      pillars: [
        { title: "专业", desc: "丰富的行业经验与专业知识" },
        { title: "诚信", desc: "以诚信为本的长期信赖关系" },
        { title: "革新", desc: "顺应时代的创新思维" },
      ],
    },
    contact: {
      eyebrow: "04 — 联系我们",
      title: "如有兴趣，欢迎随时联络。",
      description:
        "无论是咨询、洽谈，还是物件问询，欢迎您随时与我们联系。专员将以多语言为您服务。",
      address: "〒134-0088 东京都江户川区西葛西5-10-13 荣华大厦4F",
      tel: "03-6808-8841",
      fax: "03-6808-8845",
      license: "东京都知事(1)第112938号",
      lineCta: "通过 LINE 咨询",
      emailCta: "通过邮件联系",
    },
    footer: {
      tagline: "连接日本与世界的桥梁。",
      copyright: "© 2026 鸣奇株式会社 MEIKI Co., Ltd. 保留所有权利。",
    },
  },

  en: {
    nav: {
      about: "About",
      services: "Services",
      vision: "Vision",
      contact: "Contact",
      cta: "Get in touch",
    },
    hero: {
      eyebrow: "MEIKI REAL ESTATE SERVICES",
      titleLines: ["Step into a world of", "new possibilities", "in Japan."],
      subtitle: "MEIKI Co., Ltd.",
      description:
        "More than a service — a bridge that helps you experience Japan not only as a destination, but as a place to live, grow, and belong.",
      primary: "Explore services",
      secondary: "Contact us",
    },
    marquee: [
      "TOKYO",
      "REAL ESTATE",
      "EDUCATION",
      "CROSS-BORDER",
      "TRUST",
      "BESPOKE",
    ],
    about: {
      eyebrow: "01 — ABOUT",
      title: "A trusted bridge between Japan and the world.",
      paragraphs: [
        "Tokyo, as the heart of Japan, remains one of the world's most watched real estate markets. With mature infrastructure, market stability and continuous growth, it offers compelling opportunities for both residential and investment buyers.",
        "MEIKI Co., Ltd. is committed to building a professional, efficient and trustworthy cross-border service platform. Based in Japan and connecting Chinese and international markets, we deliver one-stop solutions across real estate, education and bespoke advisory.",
      ],
      stats: [
        { value: "Tokyo", label: "Headquarters" },
        { value: "Multi", label: "Languages" },
        { value: "1:1", label: "Bespoke care" },
      ],
    },
    services: {
      eyebrow: "02 — SERVICES",
      title: "Two specialized practices, one consistent standard.",
      items: [
        {
          number: "I",
          tag: "REAL ESTATE",
          title: "Real Estate Advisory",
          description:
            "Deep familiarity with every Tokyo district, from local market dynamics to development trajectories. From sourcing and analysis to transaction execution, we accompany every step of your Japan real estate journey.",
          highlights: [
            "Granular Tokyo market intelligence",
            "Residential and investment sourcing",
            "Multilingual client servicing",
            "End-to-end transaction support",
          ],
        },
        {
          number: "II",
          tag: "EDUCATION",
          title: "Japanese Language School Placement",
          description:
            "Established partnerships with multiple Tokyo-based Japanese language schools. We match each student to the right institution and guide them through application, documentation and visa procedures.",
          highlights: [
            "Wide network of partner schools",
            "Document preparation support",
            "Full visa application guidance",
            "Post-arrival life assistance",
          ],
        },
      ],
    },
    vision: {
      eyebrow: "03 — VISION",
      title: "Expertise. Integrity. Innovation.",
      body:
        "MEIKI Co., Ltd. is dedicated to the ideals of expertise, integrity and innovation — striving to remain a meaningful bridge between Japan and the world, and to create long-term value and new possibilities for every client we serve.",
      pillars: [
        { title: "Expertise", desc: "Deep industry experience and know-how" },
        { title: "Integrity", desc: "Lasting trust rooted in honest service" },
        { title: "Innovation", desc: "Forward-thinking, of-the-moment ideas" },
      ],
    },
    contact: {
      eyebrow: "04 — CONTACT",
      title: "Interested? Let's start a conversation.",
      description:
        "Whether you have a question, a property inquiry or a study plan, our multilingual team is ready to help.",
      address:
        "Eika Bldg. 4F, 5-10-13 Nishi-Kasai, Edogawa-ku, Tokyo 134-0088, Japan",
      tel: "+81-3-6808-8841",
      fax: "+81-3-6808-8845",
      license: "Tokyo Governor License No. (1) 112938",
      lineCta: "Reach us on LINE",
      emailCta: "Send us an email",
    },
    footer: {
      tagline: "Bridge between Japan and the world.",
      copyright: "© 2026 MEIKI Co., Ltd. All rights reserved.",
    },
  },
};

export default translations;
